export default __webpack_public_path__ + "static/media/Sizzling_bliss_large_3.af1614e8.jpg";